module.exports = __webpack_public_path__ + "static/media/S1N10-2.4f2f961d.svg";